import useIsPWA from "../../hooks/usePWA";
import { singleClaimedRoomRoutes, singleRoomRoutes } from "../../routes";
import { videoAppUrl } from "../../utils/axios";

interface Props {
  room: any;
}

function InstantJoinCallButton({ room }: Props) {
  const isPWA = useIsPWA();

  const goToCallPage = () => {
    const path = room?.slug
      ? singleClaimedRoomRoutes.path.replace(":slug", room.slug)
      : singleRoomRoutes.path.replace(":roomId", room._id);
    if (!isPWA) {
      window.open(`${videoAppUrl}${path}/instant`);
    } else {
      window.location.href = `${videoAppUrl}${path}/instant`;
    }
  };

  return (
    <button
      className="px-1 py-1 bg-gradient-btn-border text-white rounded-3xl "
      onClick={goToCallPage}
    >
      <div className="bg-gradient-btn flex align-center items-center  rounded-3xl justify-center px-1 sm:px-4 py-1">
        <p className="text-sm sm:text-base">⚡️Instant Join</p>
      </div>
    </button>
  );
}

export default InstantJoinCallButton;
